import { useCallback, useEffect, useState } from 'react';
import { subscriptionPlanAdminResponse } from '../Types/AdminSubscriptionPlanType';
import { getAllSubscriptionPlansFromAdmin } from '../Services/SubscriptionPlanAdminService';
import SubscriptionPlanByAdminComponent from '../Components/SubscriptionPlanByAdminComponent';

function PaymentConfigByAdminPage() {
  const [adminData, setAdminData] = useState<subscriptionPlanAdminResponse[]>([]);

  const fetchPlans = useCallback(async () => {
    try {
      const response = await getAllSubscriptionPlansFromAdmin();
      if (response.success) {
        setAdminData(response.data);
      }
    } catch (err) {
      console.error('Failed to load subscription plans', err);
    }
  }, []);

  useEffect(() => {
    fetchPlans();
  }, [fetchPlans]);

  return (
    <div>
      <SubscriptionPlanByAdminComponent
        data={adminData}
        onEditSubmit={() => {}}
        onDeleteConfirm={() => {}}
        onRegisterSubmit={() => {}}
        menuName="Subscription Plan"
        onChanged={fetchPlans}
      />
    </div>
  );
}

export default PaymentConfigByAdminPage;
